<template>
    <div class='page-main common'>
        <a-steps :current="current" class="common-step">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" ></a-step>
        </a-steps>
        <div>
            <keep-alive><component ref="modify" :is="steps[current].comp" :text="steps[current].text" passwordType="txnpswd"></component></keep-alive>
        </div>
        <div class="model-footer-btns spaceCenter">
            <a-button v-if="current == 0" style="margin-left: 8px" class="btn-big" @click="goback">
                取消
            </a-button>
            <a-button v-if="current > 0 && current < steps.length - 1" style="margin-left: 8px" class="btn-big" @click="prev">
                上一步
            </a-button>
            <a-button v-if="current < steps.length - 2" type="primary" class="btn-big" @click="next">
                下一步
            </a-button>
            <a-button
                v-if="current == steps.length - 2"
                type="primary"
               
                class="btn-big"
                @click="success"
            >
                确认
            </a-button>
            <a-button
                v-if="current == steps.length - 1"
               
                class="btn-big"
                @click="goback"
            >
                返回安全中心
            </a-button>
        </div>
    </div>
</template>

<script>
import userModify from "@/components/steps/user-modify"
import passwordModify from "@/components/steps/password-modify"
import success from "@/components/steps/success"
export default {
    name:"txnpswd-modify",
    components: {
        userModify,passwordModify,success
    },
    data() {
        return {
            current:0,
            steps:[
                {
                    title: '身份验证',
                    comp:"userModify"
                },
                {
                    title: '设置新交易密码',
                    comp:"passwordModify"
                },
                {
                    title: '提交成功',
                    comp:"success",
                    text:"交易密码修改成功"
                },
            ]
        };
    },
    computed: {},
    methods: {
        next() {
            if(this.current == 0){ //身份验证
                this.$refs["modify"].check().then(res => {
                    this.current++;
                }).catch(err => {
                    console.log(err);
                });
            }   
        },
        prev() {
            this.current--;
        },
        success(){
            this.$refs["modify"].check().then(res => {
                this.current++;
            }).catch(err => {
                console.log(err);
            });
        },
        goback(){
            this.$router.go(-1);
        }
    },
    created() {},
    watch: {}
}
</script>
<style scoped>
    .common-step{
        width: 70%;
        margin:30px auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/security/main/txnpswd-modify.vue